const actions = {
  SET_FIRST_LOAD_EVENT: '[Properties] Set first load event',
  SET_SELECTED_PROPERTY: '[Properties] Set selected property',
  setFirstLoadEvent: () => ({
    type: actions.SET_FIRST_LOAD_EVENT,
  }),
};

export default actions;
